The maximum number of events that will be sent in each HTTP request.

This number is between 1 and 10 inclusive. Defaults to 10.
